import React, { Component } from 'react';
import CountUp from "react-countup";
import Cabecalho from '../componentes/Cabecalho';
import Rodape from '../componentes/Rodape';
import { firestore } from './../firebase-config';
import { Link } from 'react-router-dom';
import { ValidatorForm, TextValidator, SelectValidator } from 'react-material-ui-form-validator';
import MenuItem from "@material-ui/core/MenuItem";
import Slider from "react-slick";
import { id_firebase, ids_firebase, href_revenda } from '../content-site';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import './Inicio.css';


function VeiculosRecentes(data) {
    const veiculos = data.veiculos;
    const listVeiculos = veiculos.map((v) =>
        <div className="item" key={v.id}>
            <div className="car-item text-center">
                <div className="car-image">
                    {
                        v.imagens.length > 0 ?
                            v.imagens[0].fileThumb !== undefined ?
                                <img className="img-fluid" src={v.imagens[0].fileThumb} alt=""></img>
                                :
                                <img className="img-fluid" src={v.imagens[0].fileUrl} alt=""></img>
                            : <img className="img-fluid" src="/img/car_default.png" alt='imagem veículo'></img>
                    }
                    <div className="car-overlay-banner">
                        <ul>
                            <li><Link to={"/veiculo/" + v.id}><i className="fa fa-link"></i></Link></li>
                        </ul>
                    </div>
                </div>
                <div className="car-list">
                    <ul className="list-inline">
                        <li><i className="fa fa-registered"></i>{v.veano_fabricacao}/{v.vefipe_ano_modelo}</li>
                        <li><i className="fa fa-cog"></i>{formatCambio(v.vecambio)}</li>
                        <li><i className="fa fa-dashboard"></i>{v.vequilometragem} KM</li>
                    </ul>
                </div>
                <div className="car-content">
                    <span>{v.veano_fabricacao}/{v.vefipe_ano_modelo}</span>
                    <Link to={"/veiculo/" + v.id}>{v.vefipe_marca} {v.vefipe_name}</Link>
                    <div className="separator"></div>
                    <div className="price">
                        <span className="new-price">{formatMoney(v.vevalor)}</span>
                    </div>
                </div>
            </div>
        </div>
    );

    return <OwlCarousel className='owl-theme' autoplay={true} loop={true} items={2} margin={30} nav>{listVeiculos}</OwlCarousel>

}

function MenuHamb(opcao) {
    const opcoes = document.querySelectorAll(".menu-hamb")

    opcoes.forEach((element) => {
        element.classList.remove("show")
        if (opcao === "ESTOQUES" || element.classList.contains(opcoes)) {
            element.classList.add("show")
        }
    })
}


function ImagensLoja(data) {

    var settings = {
        dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        accessibility: true
    };

    const imagens = data.images;
    const listImagens = imagens.map((key) =>
        <div key={key}><img className="img-responsive center-block" src={key} alt={"Banner " + data.revenda.penome_fantasia} /></div>
    );
    return <Slider {...settings}>{listImagens}</Slider>;

}

class Inicio extends Component {

    constructor(props) {
        super(props);

        this.state = {
            veiculos: [],
            veiculosComplete: [],
            countVeiculos: 0,
            instagramData: [],
            buscaVeiculo: '',
            tipoVeiculo: 'todos',
            revenda: {},
            bannerData: []
        }
        this.mounted = false;

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }

    componentDidMount() {

        window.scrollTo(0, 0);
        this.animateCounters();
        this.mounted = true;

        firestore.collection("revenda").doc(id_firebase)
            .get()
            .then(doc => {
                if (doc.exists) {
                    this.setState({
                        revenda: doc.data(),
                    });
                } else {
                    this.setState({
                        revenda: {
                            ativo: 0,
                        }
                    });
                }
            }).catch(function (error) {
            });

        const allVehicles = [];
        let completedQueries = 0;

        ids_firebase.forEach((id, index) => {
            firestore.collection("revenda").doc(id)
                .collection("veiculos")
                .where("veremovido", "==", 0)
                .where("vevendido", "==", 0)
                .orderBy("updated_at", "desc") // mais recentes primeiro
                .get()
                .then(querySnapshot => {
                    querySnapshot.forEach(doc => {
                        var vehicle = doc.data();
                        vehicle.id = doc.id;
                        vehicle.href_revenda = href_revenda[index];
                        if (vehicle["veexibir_site"] !== false) {
                            allVehicles.push(vehicle);
                        }
                    });

                    completedQueries++;

                    if (this.mounted && completedQueries === ids_firebase.length) {
                        // ordena por data e pega só os 6 mais recentes
                        allVehicles.sort((a, b) => b.updated_at - a.updated_at);

                        this.setState({
                            veiculos: allVehicles.slice(0, 3), // ← só os 6 mais recentes
                            veiculosComplete: allVehicles,
                            countVeiculos: allVehicles.length
                        });
                    }
                })
                .catch(error => {
                    console.error("Erro ao buscar veículos:", error);
                });
        });

        firestore.collection("revenda").doc(id_firebase).collection("veiculos").where("veremovido", "==", 0).where("vevendido", "==", 0).orderBy("updated_at", "desc")
            .onSnapshot(querySnapshot => {
                var items = [];
                querySnapshot.forEach(doc => {
                    var document = doc.data();
                    document.id = doc.id;
                    if (document["veexibir_site"] !== false) {
                        items.push(document);
                    }
                });
                if (this.mounted) {
                    this.setState({
                        veiculos: items,
                        veiculosComplete: items,
                        countVeiculos: items.length
                    });
                }
            });

        firestore.collection("revenda").doc(id_firebase).collection("imagem_destaque").orderBy("created_at", "desc")
            .onSnapshot(querySnapshot => {
                var items = [];
                querySnapshot.forEach(doc => {
                    var document = doc.data();
                    document.id = doc.id;
                    items.push(document);
                });
                if (this.mounted) {
                    this.setState({
                        instagramData: items
                    });
                }
            });

        firestore.collection("revenda").doc(id_firebase).collection("banner_site").orderBy("created_at", "desc")
            .onSnapshot(querySnapshot => {
                var items = [];
                querySnapshot.forEach(doc => {
                    var document = doc.data();
                    document.id = doc.id;
                    if (document.imagem_url !== undefined && document.imagem_url.trim().length > 0) {
                        items.push(document.imagem_url);
                    }
                });
                if (this.mounted) {
                    this.setState({
                        bannerData: items
                    });
                }
            });

    }

    animateCounters() {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (!entry.isIntersecting) return;

                const counters = entry.target.querySelectorAll('.stat-val');
                counters.forEach(counter => {
                    const target = parseInt(counter.dataset.target);
                    const steps = 1500 / 16;
                    const increment = target / steps;
                    let current = 0;

                    const timer = setInterval(() => {
                        current += increment;
                        if (current >= target) {
                            counter.textContent = target;
                            clearInterval(timer);
                        } else {
                            counter.textContent = Math.floor(current);
                        }
                    }, 16);
                });

                observer.unobserve(entry.target);
            });
        }, { threshold: 0.3 });

        const heroStats = document.querySelector('.hero-stats');
        if (heroStats) observer.observe(heroStats);

        // Guarda o observer para limpar depois
        this.observer = observer;
    }

    componentWillUnmount() {
        this.mounted = false;
        if (this.observer) this.observer.disconnect();
    }

    handleChange(event) {

        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    handleSubmit(event) {

        let filtro = this.state.buscaVeiculo.toLowerCase();
        let tipoVeiculo = this.state.tipoVeiculo;

        let veiculosFilter = this.state.veiculosComplete.filter(function (veiculo) {
            let descricaoVeiculo = veiculo.vefipe_marca.toLowerCase() + " " + veiculo.vefipe_name.toLowerCase();
            if (tipoVeiculo === 'novos') {
                return descricaoVeiculo.includes(filtro) && veiculo.vequilometragem <= 100;
            }
            if (tipoVeiculo === 'seminovos') {
                return descricaoVeiculo.includes(filtro) && veiculo.vequilometragem > 100;
            }
            return descricaoVeiculo.includes(filtro);
        });

        this.setState({
            veiculos: veiculosFilter
        });

    }

    handleClick(event) {
        this.setState({
            veiculos: this.state.veiculosComplete,
            buscaVeiculo: '',
            tipoVeiculo: 'todos',
        });
    }

    render() {
        const {
            veiculos,
            instagramData,
            tipoVeiculo,
            bannerData
        } = this.state;

        const veiculosRecentes = this.state.veiculos.slice(0, 3);
        console.log("veiculos:", this.state.veiculos);

        if (this.state.revenda.ativo === 0) {
            return (
                <div style={{ textAlign: "center" }}>
                    <h1>Site em manutenção.</h1>
                    <h3>Contate o suporte para mais detalhes (suporte@intermedioveiculos.com.br)</h3>
                </div>
            )
        }



        return (
            <div>
                <Cabecalho revenda={this.state.revenda} />
                <section class="hero">
                    <div class="hero-bg"></div>

                    <div class="hero-content">
                        <span class="hero-label">CENTRAL · São Paulo</span>
                        <h1 class="hero-title">
                            Sua próxima<br />
                            <em>conquista,</em> com<br />
                            certificado de <br /><em>qualidade.</em>
                        </h1>
                        <p class="hero-sub">
                            Veículos com rigoroso controle de qualidade e histórico verificado.
                            Sua confiança é nossa principal prioridade.
                        </p>
                        <div className="hero-stats">
                            <div className="stat-block">
                                <CountUp end={180} duration={5} className="stat-value" />
                                <span className="stat-suffix">+</span>
                                <p className="stat-label">Veículos Disponíveis</p>
                            </div>

                            <div className="stat-block">
                                <CountUp end={20} duration={5} className="stat-value" />
                                <span className="stat-suffix">+</span>
                                <p className="stat-label">Anos de Mercado</p>
                            </div>

                            <div className="stat-block">
                                <CountUp end={10} duration={5} className="stat-value" />
                                <span className="stat-suffix">k</span>
                                <p className="stat-label">Clientes ativos</p>
                            </div>
                        </div>
                    </div>

                    <div class="hero-insta">
                        <div class="hero-insta-circle">
                            <div class="hero-insta-inner">
                                <img
                                    src="/images/logos/intagram.png"
                                    alt="Instagram"
                                    class="hero-insta-icon"
                                />
                                <div class="hero-insta-text">
                                    <span class="hero-insta-siga">SIGA-NOS NO</span>
                                    <strong class="hero-insta-nome">INSTAGRAM</strong>
                                    <span class="hero-insta-linha"></span>
                                    <p class="hero-insta-desc">
                                        Acompanhe ofertas exclusivas, novidades, lançamentos e os melhores veículos.
                                    </p>
                                    <a class="hero-insta-handle" href="https://www.instagram.com/autoshoppingcentral.com.br/" target="_blank">
                                        <i class="fa fa-instagram"></i>
                                        @autoshoppingcentral.com.br
                                    </a>
                                    <div class="hero-insta-seguidores">
                                        <i class="fa fa-users"></i>
                                        Mais de <span>3.8 mil</span> seguidores
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="hero-dots"></div>
                    </div>
                </section>

                <div class="recent-vehicles">
                    <div class="recent-title">
                        <h1>Veículos <span style={{ color: '#F5C518' }}>Recentes</span></h1>
                        <p>Venha conferir nossas novidades!</p>
                    </div>


                    <div className="row">

                        {veiculosRecentes.map(v => (
                            <div className="col-lg-4" key={v.id}>
                                <Link to={`/${v.href_revenda}/${v.id}`} style={{ textDecoration: 'none' }}>
                                    <div className="car-item">

                                        <div className="car-image">
                                            <img
                                                src={
                                                    v.imagens?.length > 0
                                                        ? v.imagens[0].fileUrl
                                                        : "/images/car_default.png"
                                                }
                                                alt={v.vefipe_name}
                                            />
                                            <span className={`car-badge ${v.vequilometragem <= 100 ? 'novo' : 'usado'}`}>
                                                {v.vequilometragem <= 100 ? 'Novo' : 'Seminovo'}
                                            </span>
                                            <span className="car-km">
                                                {v.vequilometragem.toLocaleString('pt-BR')} km
                                            </span>
                                        </div>

                                        <div className="car-body">
                                            <div className="car-make">{v.vefipe_marca}</div>
                                            <div className="car-model">{v.vefipe_name}</div>
                                            <div className="car-specs">
                                                <span className="car-spec">{v.veano_fabricacao}/{v.vefipe_ano_modelo}</span>
                                                <span className="car-spec">{formatCambio(v.vecambio)}</span>
                                            </div>
                                            <div className="car-footer">
                                                <div>
                                                    <div className="car-price-label">Apenas por</div>
                                                    <div className="car-price">{formatMoney(v.vevalor)}</div>
                                                </div>
                                                <div className="car-arrow">›</div>
                                            </div>
                                        </div>

                                    </div>
                                </Link>
                            </div>
                        ))}
                    </div>
                </div>

                <section className="parceiros-section">
                    <h2 className="parceiros-titulo">Conheça as lojas <span style={{ color: "yellow" }}>parceiras</span></h2>
                    <div className="parceiros-grid">

                        <a className="parceiro-card" target="_blank" href="http://b8veiculos.autoshoppingcentral.com.br">
                            <img src="/images/logos/b8veiculos.png" alt="B8 Veículos" className="parceiro-logo" />
                        </a>

                        <a className="parceiro-card" target="_blank" href="http://gf7.autoshoppingcentral.com.br/">
                            <img src="/images/logos/kar.png" alt="Kar" className="parceiro-logo" />
                        </a>

                        <a className="parceiro-card" target="_blank" href="http://mamultimarcas.autoshoppingcentral.com.br">
                            <img src="/images/logos/mea.png" alt="M&A" className="parceiro-logo" style={{ transform: 'scale(2.0)', transformOrigin: 'center', objectFit: 'contain' }} />
                        </a>

                        <a className="parceiro-card-2" target="_blank" href="https://maverick.autoshoppingcentral.com.br">
                            <img src="/images/logos/maverick.png" alt="Maverick" className="parceiro-logo" />
                        </a>

                        <a className="parceiro-card" target="_blank" href="http://dcar.autoshoppingcentral.com.br">
                            <img src="/images/logos/dcar.png" alt="Dcar Motors" className="parceiro-logo" style={{ transform: 'scale(2.0)', transformOrigin: 'center', objectFit: 'contain' }} />
                        </a>

                        <a className="parceiro-card-2" target="_blank" href="http://topcristal1.autoshoppingcentral.com.br">
                            <img
                                src="/images/logos/topcristal.png"
                                alt="Top Cristal"
                                className="parceiro-logo"
                                style={{ transform: 'scale(6.0)', transformOrigin: 'center', objectFit: 'contain' }}
                            />
                        </a>

                        <a className="parceiro-card-2" target="_blank" href="http://topcristal1.autoshoppingcentral.com.br">
                            <img src="/images/logos/flap.png" alt="La Voiture Motors" className="parceiro-logo" />
                        </a>

                        <a className="parceiro-card" target="_blank" href="http://flexmotors.autoshoppingcentral.com.br">
                            <img src="/images/logos/flex.png" alt="99 Veículos" className="parceiro-logo" />
                        </a>

                        <a className="parceiro-card" target="_blank" href="http://grsveiculos.autoshoppingcentral.com.br">
                            <img src="/images/logos/grs.png" alt="99 Veículos" className="parceiro-logo"
                            style={{ transform: 'scale(3.0)', transformOrigin: 'center', objectFit: 'contain' }} />
                        </a>
                    </div>
                </section>

                <div>
                    <h2 class="partner-logos-title">NOSSOS PARCEIROS</h2>
                </div>

                <section class="partner-logos-section">

                    <div class="swiper-wrapper">
                        <div class="swiper-track">

                            {/* lista original */}
                            <img src="../images/logos/santander.png" alt="Santander" class="partner-logo-item" />
                            <img src="../images/logos/itau.png" alt="Itaú" class="partner-logo-item" />
                            <img src="../images/logos/potencia.png" alt="Safra" class="partner-logo-item" />
                            <img src="../images/logos/evydhence.jpg" alt="Evydhence" class="partner-logo-item" />

                            {/* duplicata para loop contínuo */}
                            <img src="../images/logos/santander.png" alt="Santander" class="partner-logo-item" />
                            <img src="../images/logos/itau.png" alt="Itaú" class="partner-logo-item" />
                            <img src="../images/logos/potencia.png" alt="Safra" class="partner-logo-item" />
                            <img src="../images/logos/evydhence.jpg" alt="Evydhence" class="partner-logo-item" />

                            {/* triplicata pq eu to ficando maluco */}
                            <img src="../images/logos/santander.png" alt="Santander" class="partner-logo-item" />
                            <img src="../images/logos/itau.png" alt="Itaú" class="partner-logo-item" />
                            <img src="../images/logos/potencia.png" alt="Safra" class="partner-logo-item" />
                            <img src="../images/logos/evydhence.jpg" alt="Evydhence" class="partner-logo-item" />


                        </div>
                    </div>
                </section>
                <section className="empresa-section" id="empresa">
                    <div className="empresa-header">
                        <div className="empresa-label">Sobre nós</div>
                        <h2 className="empresa-titulo">Conheça o Auto Shopping CENTRAL</h2>
                    </div>

                    <div className="empresa-fotos">
                        <div className="empresa-foto">
                            <img src="images/trimestrais/01.jpg" alt="Interior da loja" />

                        </div>
                        <div className="empresa-foto">
                            <img src="images/trimestrais/02.jpg" alt="Fachada" />

                        </div>
                        <div className="empresa-foto">
                            <img src="images/trimestrais/03.jpg" alt="Vista aérea" />

                        </div>
                    </div>

                    <div className="empresa-pontos">
                        <div className="empresa-ponto">
                            <i className="fas fa-building empresa-ponto-icon"></i>
                            <h3 className="empresa-ponto-titulo">Modernas instalações</h3>
                            <p className="empresa-ponto-desc">Nossa loja foi projetada para proporcionar a melhor experiência aos nossos clientes, com instalações modernas e aconchegantes.</p>
                        </div>
                        <div className="empresa-ponto">
                            <i className="fas fa-car empresa-ponto-icon"></i>
                            <h3 className="empresa-ponto-titulo">Exposição de veículos</h3>
                            <p className="empresa-ponto-desc">A exposição dos nossos veículos é feita com segurança e conforto, para que você possa escolher o seu próximo carro com tranquilidade.</p>
                        </div>
                        <div className="empresa-ponto">
                            <i className="fas fa-headset empresa-ponto-icon"></i>
                            <h3 className="empresa-ponto-titulo">Atendimento personalizado</h3>
                            <p className="empresa-ponto-desc">Nosso atendimento é personalizado e exclusivo, para que você se sinta à vontade e escolha o seu próximo carro com confiança.</p>
                        </div>
                    </div>
                </section>

                <hr className="gray"></hr>

                <Rodape revenda={this.state.revenda} />
            </div >
        )
    }
}

function formatMoney(value) {

    var places = 2;
    var symbol = "R$ ";
    var thousand = ".";
    var decimal = ",";

    places = !isNaN(places = Math.abs(places)) ? places : 2;
    symbol = symbol !== undefined ? symbol : "$";
    thousand = thousand || ",";
    decimal = decimal || ".";
    var number = value,
        negative = number < 0 ? "-" : "",
        i = parseInt(number = Math.abs(+number || 0).toFixed(places), 10) + "",
        j = (j = i.length) > 3 ? j % 3 : 0;
    return symbol + negative + (j ? i.substr(0, j) + thousand : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousand) + (places ? decimal + Math.abs(number - i).toFixed(places).slice(2) : "");
};

function formatCambio(value) {
    if (value === 'A') {
        return "Automático";
    } else {
        return "Manual";
    }
}

export default Inicio